import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  FELADATOK és KÖRÖZTETÉS.
 *
 *  Egy felelősnek egyszerű feladat, többnek köröztetés. A köröztetés alapból SOROS:
 *  a lánc következő tagja csak akkor kapja meg, ha az előző lezárta – így a
 *  véleményezési sorrend valóban sorrend, nem egyszerre kiküldött körlevél. Aki
 *  párhuzamosan akarja, egy kapcsolóval megkapja.
 */
@Component({
  selector: 'app-ikt-feladatok',
  templateUrl: './feladatok.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktFeladatokComponent implements OnInit {
  nezet: 'sajat' | 'mind' = 'sajat';
  feladatok: any[] = [];
  ugyintezok: any[] = [];
  munkaasztal: any = null;
  betoltes = false;

  ujNyitva = false;
  uj: any = {
    targy_tipus: 'ugyirat', targy_id: '', tipus: 'ugyintezes', cim: '', leiras: '',
    felelosok: [], hatarido: '', prioritas: 'normal', parhuzamos: false,
  };
  ugyiratok: any[] = [];

  readonly TIPUSOK = [
    { kulcs: 'szignalas', nev: 'szignálás' },
    { kulcs: 'ugyintezes', nev: 'ügyintézés' },
    { kulcs: 'velemenyezes', nev: 'véleményezés' },
    { kulcs: 'jovahagyas', nev: 'jóváhagyás' },
    { kulcs: 'korozteles', nev: 'köröztetés' },
    { kulcs: 'egyeb', nev: 'egyéb' },
  ];

  constructor(private ikt: IktatgatoService, private data: DataService, private router: Router) {}

  async ngOnInit() {
    await this.betolt();
    try {
      this.ugyintezok = await this.ikt.ugyintezok();
      this.ugyiratok = (await this.ikt.ugyiratok({ allapot: 'folyamatban' })).ugyiratok || [];
    } catch { /* a lista enélkül is használható */ }
  }

  async betolt() {
    this.betoltes = true;
    try {
      this.feladatok = await this.ikt.feladatok(this.nezet === 'sajat' ? { sajat: 1 } : {});
      this.munkaasztal = await this.ikt.munkaasztal();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A feladatok nem tölthetők be.', 'error');
    } finally { this.betoltes = false; }
  }

  async nezetValt(n: 'sajat' | 'mind') { this.nezet = n; await this.betolt(); }

  allapotSzin(f: any) {
    if (f.allapot === 'kesz') return 'success';
    if (f.allapot === 'elutasitva') return 'danger';
    if (f.lejart) return 'danger';
    if (f.allapot === 'varakozik') return 'medium';
    return 'primary';
  }

  async allapot(f: any, allapot: string) {
    try {
      const r = await this.ikt.feladatModosit(f.id, { allapot });
      this.data.sendToast(r?.kovetkezo
        ? 'Lezárva – a köröztetés következő tagja megkapta.'
        : 'Frissítve.');
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A művelet nem sikerült.', 'error');
    }
  }

  async kiad() {
    if (!this.uj.cim?.trim()) { this.data.sendToast('A feladat megnevezése kötelező.', 'warning'); return; }
    if (!this.uj.targy_id) { this.data.sendToast('Válassz ügyiratot.', 'warning'); return; }
    if (!this.uj.felelosok?.length) { this.data.sendToast('Válassz legalább egy felelőst.', 'warning'); return; }
    try {
      const r = await this.ikt.feladatKiad(this.uj);
      this.data.sendToast(r.korozes ? 'Köröztetés elindítva.' : 'Feladat kiadva.', 'success');
      this.ujNyitva = false;
      this.uj = { ...this.uj, cim: '', leiras: '', felelosok: [], hatarido: '' };
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A kiadás nem sikerült.', 'error');
    }
  }

  ugyiratra(f: any) {
    if (f.targy_tipus === 'ugyirat') this.router.navigateByUrl('/iktatgato/ugyirat/' + f.targy_id);
    else this.router.navigateByUrl('/iktatgato/irat/' + f.targy_id);
  }
}
